const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Plugin search", "uipress-lite"),
  moduleName: "uip-plugin-search",
  description: __("Search the plugin directory with quick filters, discover new plugins and install all from one block", "uipress-lite"),
  group: "dynamic",
  icon: "extension",
};
